<script lang="ts" setup>
type Props = {
  step: number;
  totalStep: number;
  disable: boolean;
  buttonText: string;
  loading: boolean;
};
import { GLoadingButton } from '@modules/common';
import Button from '@/modules/common/components/Button/index.vue';

const { loading, disable } = defineProps<Props>();
const emit = defineEmits(['submit']);
const click = () => {
  // console.log('disabledisable', disable);
  // if (disable) {
  //   return;
  // }
  emit('submit');
};
</script>

<template>
  <div class="feedback-bottom !px-4 !pb-4 h-[48px] sticky flex items-center justify-between">
    <div class="flex justify-between w-full items-center">
      <Button
        theme="dark"
        type="secondary"
        :disabled="disable"
        @click="click"
        class="cursor-pointer bg-dark-300 text-light-100 text-xs font-medium flex items-center justify-center w-full h-[32px] rounded-[3px]">
        <GLoadingButton size="medium" v-if="loading" />
        <template v-if="!loading"> Submit </template>
      </Button>
    </div>
  </div>
</template>
